import React, { useEffect, useState } from "react";
import ServiceRequestView from "./ServiceRequestView";
import crmservices from '../../wsclient';
import AddServiceRequestController from "./AddServiceRequestController";
import { custom_page } from "../../custom.config";
import ServiceRequestDetailController from "./ServiceRequestDetailController";
import ServiceRequestFilterView from "./ServiceRequestFilterView";

const PAGE_SIZE = 10;
const ServiceRequestPage = custom_page.service_request && custom_page.service_request.view ? require('../../custom_src/pages/service-request/ServiceRequestView').default : ServiceRequestView;

export default function ServiceRequestController(props){
    const [showProcessing, setShowProcessing] = useState(false);
    const [message, setMessage] = useState(null);
    const [showLoading, setShowLoading] = useState(false);
    const [showLoadingDetail, setShowLoadingDetail] = useState(false);
    const [serviceRequest, setServiceRequest] = useState(null);
    const [showAddSR, setShowAddSR] = useState(false);
    const [serviceRequestNotes, setServiceRequestNotes] = useState([]);
    const [showDetail, setShowDetail] = useState(false);
    const [params, setParams] = useState({});
    const [showLoadMoreServiceRequests, setShowLoadMoreServiceRequests] = useState(false);
    const [openSearch, setOpenSearch] = useState(false);
    const [showLoadingServiceRequestsByValue, setShowLoadingServiceRequestsByValue] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [isSelectedFilter, setIsSelectedFilter] = useState(false);
    const [serviceRequests, setServiceRequests] = useState({
            content: [],
            paging: {
                page: 1,
                size: PAGE_SIZE,
                total: 0,
                has_more: false
            }
        });;
    
    const [filter_options, setFilterOptions] = useState(null);
    const [filter_options_org, setFilterOptionsOrg] = useState({
        states: [
            { id: "NEW", name: "New" },
            { id: "IN_PROGRESS", name: "In Progress" },
            { id: "CLOSED", name: "Closed" }],
        queue_id : []
        });
    const [filterSelected, setFilterSelected] = useState({
        states: [{ id: "ALL", name: "All" }],
        queue_id: [{ id: "ALL", name: "All" }]
    });
  

    useEffect(() => {
        onLoadServiceRequests();
        onLoadClassification();
    },[])

    const onLoadClassification = async () => {
        setShowProcessing(true)
        try {
            const result = await crmservices.servicerequest.getListServiceRequestQueues();
            if (result.code == 'OK' && result.data.content) {
                let queues = [...result.data.content]
                queues.forEach(element => {
                    element.label = element.name
                    element.value = element.id
                });
                var filter_options = filter_options_org;
                var queue_id = [];
                result.data.content.forEach(item => {
                    let classification = {
                        id: item.id,
                        name: item.classification,
                    };
                    queue_id.push(classification);
                });
                filter_options.queue_id = queue_id;
                setFilterOptionsOrg(filter_options);
            }
        } catch (error) {
            console.log('onLoadClassification exception error:', error)
        }
        setShowProcessing(false)
    }
    

    const onLoadServiceRequests = async (params) => {
        setShowProcessing(true);
        try {
            if(params &&params.states === 'ALL') {
                params.states = null;
            }
            if(params && params.queue_id === 'ALL') {
                params.queue_id = null;
            }
            var result = await crmservices.servicerequest.getListServiceRequests({
                ...params,
                inclide_total: true,
                page: 1,
                size: PAGE_SIZE,
            });
            if (result.code == 'OK') {
                let srs = result.data.content.length > 0 ? result.data.content : [];
                setServiceRequests({
                    content: srs,
                    paging: result.data.paging
                });
            }
        } catch (error) {}
        setShowProcessing(false);
    }

    const onShowDetail = (item) => {
        setShowDetail(true);
        setServiceRequest(item);
    }

    const searchServiceRequests = async (searchText) => {
        setShowLoadingServiceRequestsByValue(true);
        if(params &&params.states === 'ALL') {
            params.states = null;
        }
        var result = await crmservices.servicerequest.getListServiceRequests({
            ...params,
            page: 1,
            size: PAGE_SIZE,
            search_value: searchText,
        });
        if (result.code == 'OK') {
            let srs = result.data.content.length > 0 ? result.data.content : [];
            setServiceRequests({
                content: srs,
                paging: result.data.paging
            });
        }
        setShowLoadingServiceRequestsByValue(false);
    }

    const handleLoadMoreserviceRequests = async () => {
        try {
            setShowLoadMoreServiceRequests(true);
            let _serviceRequests = serviceRequests ? [...serviceRequests.content] : [];
            var page = serviceRequests.paging && serviceRequests.paging.page ? serviceRequests.paging.page + 1 : 0;
                var result =  await crmservices.servicerequest.getListServiceRequests({
                    inclide_total: true,
                    page: page,
                    size: PAGE_SIZE,
                });
                if (result.code === 'OK') {
                    if (result.data && result.data.content && result.data.content.length > 0) {
                        
                        let _paging = result.data && result.data.paging ? result.data.paging : {
                            total: 0,
                            size: PAGE_SIZE,
                            page: 1,
                        };
                        _serviceRequests = [..._serviceRequests, ...result.data.content];
                        setServiceRequests({
                            content:_serviceRequests,paging:_paging});
                    }
                }
                setShowLoadMoreServiceRequests(false);
                // }
            } catch (error) {
                setShowLoadMoreServiceRequests(false);
            }
        }
    
    const onClickSearch = async () => {
        setOpenSearch(!openSearch);
    }

    const onOpenFilter = async () => {
        var filter_options = { ...filter_options_org };
        filter_options.states = [{ id: "ALL", name: "All" }, ...filter_options.states];
        filter_options.queue_id = [{ id: "ALL", name: "All" }, ...filter_options.queue_id];

        setOpenFilter(true);
        setFilterOptions(filter_options)
        setIsSelectedFilter(false);
    }

    const onSelectFilterAndSearch = async (type, value) => {
        let newFilt = await onSelectFilter(type, value);
        await onFilter(newFilt);
    }

    const onSelectFilter = async (type, value) => {
        var new_filter_options = { ...filter_options };
        var newFilterSelected = { ...filterSelected };
        if (value.id === 'ALL') {
            newFilterSelected[type] = [{ id: "ALL", name: "All" }];
        }
        else {
            if (newFilterSelected[type].length === 1 && newFilterSelected[type][0].id === 'ALL') {
                newFilterSelected[type].splice(0, 1);
            }
            let index = -1;
            for (var i = 0; i < newFilterSelected[type].length; i++) {
                if (newFilterSelected[type][i].id === value.id) {
                    index = i;
                    break;
                }
            }
            if(type=="queue_id") {
                newFilterSelected[type] = [];
            }
            if (index >= 0) {
                newFilterSelected[type].splice(index, 1);
            }
            else {
                newFilterSelected[type].push(value);
            }
            if (newFilterSelected[type].length === 0) {
                newFilterSelected[type] = [{ id: "ALL", name: "All" }]
            }
        }

        setFilterOptions(new_filter_options);
        setFilterSelected(newFilterSelected);
        setIsSelectedFilter(true);

        return newFilterSelected;
    }

    const onCloseFilter = async () => {
        if (isSelectedFilter) {
            await onFilter();
        }
        setOpenFilter(false);
    }

    const getFilterParamByType = (selectedType, paramType, new_params, _filterSelectedList) => {
        if (!_filterSelectedList) {
            _filterSelectedList = filterSelected;
        }
        var newFilterSelected = _filterSelectedList[selectedType];
        if (newFilterSelected.length > 0 && newFilterSelected[0].id !== 'ALL') {
            new_params[paramType] = "";
            for (var i = 0; i < newFilterSelected.length; i++) {
                if (i === newFilterSelected.length - 1) {
                    new_params[paramType] = new_params[paramType] + newFilterSelected[i].id;
                } else {
                    new_params[paramType] = new_params[paramType] + newFilterSelected[i].id + ",";
                }
            }
        }
        else {
            delete new_params[paramType]
        }
        return new_params;
    }

    const onFilter = async (newFilt) => {
        setShowLoading(true);
        let new_params = { ...params }
        new_params = getFilterParamByType("states", "states", new_params, newFilt);
        new_params = getFilterParamByType("queue_id", "queue_id", new_params, newFilt);
        await onLoadServiceRequests(new_params);
        setShowLoading(false);
        setParams(new_params);
    }

    return(
        <>
            <ServiceRequestPage 
                showProcessing={showProcessing}
                message={message}
                serviceRequests={serviceRequests}
                showLoading={showLoading}
                serviceRequest={serviceRequest}
                showLoadingDetail={showLoadingDetail}
                open={props.open}
                onClose={props.onClose}
                setShowAddSR={setShowAddSR}
                serviceRequestNotes={serviceRequestNotes}
                handleLoadMoreserviceRequests={handleLoadMoreserviceRequests}
                showLoadMoreServiceRequests={showLoadMoreServiceRequests}
                onShowDetail={onShowDetail}
                onClickSearch={onClickSearch}
                openSearch={openSearch}
                searchServiceRequests={searchServiceRequests}
                showLoadingServiceRequestsByValue={showLoadingServiceRequestsByValue}
                onOpenFilter={onOpenFilter}
                filterSelected={filterSelected}
                onSelectFilter={onSelectFilterAndSearch}
            />
            {showAddSR && <AddServiceRequestController 
                open={showAddSR}
                onRefresh={onLoadServiceRequests}
                onClose={() => setShowAddSR(false)}
            />}
            {showDetail && <ServiceRequestDetailController 
                open={showDetail}
                serviceRequest={serviceRequest}
                serviceRequests={serviceRequests}
                setServiceRequests={setServiceRequests}
                onClose={() => setShowDetail(false)}
                serviceRequestNotes={serviceRequestNotes}
                // onSaveFilesState={onSaveFilesState}
            />}
            {openFilter && <ServiceRequestFilterView
                open={openFilter}
                showLoading={showLoading}
                filter_options={filter_options}
                filterSelected={filterSelected}
                onSelectFilter={onSelectFilter}
                onApplyFilter={onCloseFilter}
                onClose={onCloseFilter}
            />}
        </>
    )
}